var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeploimentAts32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.384,
    height: 32,
    viewBox: "0 0 32.384 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.c{fill:#fff;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    transform: "translate(0.185)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.925 -115.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.689,128.9a10.589,10.589,0,1,1,10.588,10.588A10.589,10.589,0,0,1,36.689,128.9ZM46,124.77a.529.529,0,0,0-.847.424v7.413a.529.529,0,0,0,.847.424l4.943-3.7a.523.523,0,0,0,0-.847Z",
    transform: "translate(1.236 2.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.924,128.949H65.137l-4.9,4.9a1.011,1.011,0,0,0,0,1.425,1,1,0,0,0,1.413,0h0l6.615-6.615a1,1,0,0,0,0-1.413v0l-6.605-6.623a1,1,0,1,0-1.416,1.414l4.889,4.908H53.924a1,1,0,0,0,0,2.009h0Z",
    transform: "translate(1.747 3.22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploimentAts32Px);
export default __webpack_public_path__ + "static/media/deploiment_ats_32px.4d28ed7ecd1313a748717615e4ad432b.svg";
export { ForwardRef as ReactComponent };